import styled from "styled-components";

const MarketingContainer = styled.div`
    padding-top: 2rem;
    @media only screen and (min-width: ${props => props.theme.tablet}) {
        padding-top: 5rem;
        button {
            margin-top: 1rem;
        }
    }
    h5 {
        margin-bottom: 1rem;
    }
`;

const MarketingSection = styled.div`
	margin-top: 2.4rem;
	padding-top: 2.4rem;
	border-top: ${props => props.theme.midGreyBorder};

	@media only screen and (min-width: ${props => props.theme.tablet}) {
		display: flex;
		
		> div:first-of-type {
			flex: 2;
		}

		> div:last-of-type {
			flex: 1 1 37.5rem;
			padding-right: 6rem;
			text-align: right;
		}
	}

	@media only screen and (min-width: ${props => props.theme.desktopSmall}) {
		> div:last-of-type {
			padding-right: 10rem;
		}
	}
`;

export { 
	MarketingContainer, 
	MarketingSection 
};
